import { HeaderState } from 'models/HeaderState';
import { VoyadoCart, VoyadoCartEvent, VoyadoCartItem } from '../types';
import { GtmVoyadoCartUpdateAction } from '../actions';

const SWE_LOCALE = 'sv-SE';
const NOR_LOCALE = 'nb-NO';

const getVoyadoLocale = (channel: string): string => {
  return channel === 'BNO' ? NOR_LOCALE : SWE_LOCALE;
};

export const getVoyadoCartEvent = (
  action: GtmVoyadoCartUpdateAction,
  state: HeaderState
): VoyadoCartEvent => {
  const voyadoCartItems: VoyadoCartItem[] = [];

  const cart = action.cart ?? state.cart;

  cart.cartItems.forEach(item => {
    voyadoCartItems.push({
      itemId: item.productId,
      quantity: item.quantity.amount
    } as VoyadoCartItem);

    cart.subItemRelations[item.cartItemId]?.items.forEach(subItem => {
      voyadoCartItems.push({
        itemId: subItem.productId,
        quantity: subItem.quantity.amount
      });
    });
  });

  const voyadoCart: VoyadoCart = {
    cartRef: cart.cartId,
    cartUrl: cart.cartUrl,
    contactId: '',
    items: voyadoCartItems,
    locale: getVoyadoLocale(state.appShell.channel)
  };

  return {
    event: 'voyado_cart',
    cart: voyadoCart
  };
};
